import { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Asset } from '../../../../../types/apiTypes';
import AssetForm from './widgets/asset-form/AssetForm';
import AssetDetails from './AssetDetails';
import AssetsHome from './AssetsHome';
import { useQueryClient } from '@tanstack/react-query';
import SubmitMileage from './SubmitMileage';
import OdometerHistory from './OdometerHistory';

interface CustomerAssetsProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
  currSubPage: string | null;
  setCurrSubPage: (page: string | null) => void;
}

function CustomerAssets({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
  currSubPage,
  setCurrSubPage,
}: CustomerAssetsProps) {
  const [selectedAsset, setSelectedAsset] = useState<Asset | null>(null);
  const updateSelectedAsset = (asset: Asset | null) => {
    setSelectedAsset(asset);
  };

  const queryClient = useQueryClient();

  const refreshAssets = () => {
    queryClient.invalidateQueries({ queryKey: ['assets'] });
  };

  const props = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
    currSubPage,
    setCurrSubPage,
    selectedAsset,
    setSelectedAsset: updateSelectedAsset,
    onAssetChange: refreshAssets,
  };

  return (
    <Routes>
      <Route path="/" element={<AssetsHome {...props} />} />
      <Route path="create" element={<AssetForm mode="create" />} />
      <Route path="submit-mileage" element={<SubmitMileage {...props} />} />
      <Route
        path="odometer-history/:truckId"
        element={<OdometerHistory {...props} />}
      />
      <Route
        path=":asset_type/:asset_id/*"
        element={<AssetDetails {...props} />}
      />
    </Routes>
  );
}

export default CustomerAssets;
